import axios from "axios";
import { API_URL, getHeaders } from "../config";

/**
 * The learner's assigned SCORM courses. Self-contained: talks only to the
 * additive /api/scorm endpoints and never affects the role-based catalog.
 */
export const getMyScorm = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/api/scorm/mine`, {
      headers: getHeaders().headers,
    });
    return data?.data ?? [];
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return [];
  }
};

/**
 * Launch a SCORM course: fetch a short-lived launch ticket, then open the
 * backend-hosted player in a new tab (backend origin => first-party cookie,
 * no CORS issues, correct SCORM API discovery).
 */
export const launchScorm = async (scormId) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/scorm/${scormId}/ticket`, {
      headers: getHeaders().headers,
    });
    const url = data?.data?.url;
    if (url) window.open(url, "_blank", "noopener");
    return !!url;
  } catch (error) {
    console.log(error);
    return false;
  }
};
